
import { defineComponent } from 'vue';

import IconList from './IconList.vue';
import IconListItem from './IconListItem.vue';
import { icons } from './assets/icons';

export default defineComponent({
  name: 'GrayscaleIcons',

  components: {
    IconList,
    IconListItem
  },

  setup() {
    return {
      icons
    };
  }
});
